/* global G */
import { curry } from 'lib/util'
import status from 'model/ticket/collection/filter/status'

/**
 * @param {Gaia.AppModule.Spec} module - app module
 * @param {Gaia.Component.Spec} component - action component
 * @param {Gaia.PlatformEvent} event - event
 * @returns {Array} countries
 */
// eslint-disable-next-line no-unused-vars
const listTicketFilterStatus = (module, component, event) => {
  return status.map(item => ({
    ...item,
    value: module[G.ADAPTER][G.INTL]._t(
      `filter.status.${item.key}`,
      { ns: 'ticket', _key: `filter.status.${item.key}`, defaultValue: item.value },
    ),
  }))
}

export default curry(listTicketFilterStatus)
